/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_TocInputs */

const en_landing_guide_toc = /** @type {(inputs: Landing_Guide_TocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this page`)
};

const zh_landing_guide_toc = /** @type {(inputs: Landing_Guide_TocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本页内容`)
};

/**
* | output |
* | --- |
* | "On this page" |
*
* @param {Landing_Guide_TocInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_toc = /** @type {((inputs?: Landing_Guide_TocInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_TocInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_toc(inputs)
	return zh_landing_guide_toc(inputs)
});
export { landing_guide_toc as "landing.guide.toc" }